import { assert } from '../../../app/logger.js';

/**
 * A wrapper around GoogleMaps popup.
 */
class PopupGoogleMaps {
  constructor(content) {
    this.native = new (class extends window.google.maps.OverlayView {
      constructor(wrapper) {
        super();
        this.wrapper = wrapper;
      }

      onAdd() {
        this.getPanes().floatPane.appendChild(this.wrapper.anchorEl);
        this.wrapper.moved = false;
      }

      onRemove() {
        if (this.wrapper.anchorEl.parentElement) {
          this.wrapper.anchorEl.parentElement.removeChild(
            this.wrapper.anchorEl
          );
        }
      }

      /** Called when the popup needs to draw itself. */
      draw() {
        const kOffset = 50;
        let divPosition = this.getProjection().fromLatLngToDivPixel({
          lng: this.wrapper.loc.lng,
          lat: this.wrapper.loc.lat,
        });
        // Hide the popup when it is far out of view.
        let hidden = !(
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
        );

        if (!hidden) {
          this.wrapper.anchorEl.style.left = `${divPosition.x}px`;
          this.wrapper.anchorEl.style.top = `${divPosition.y - kOffset}px`;
        }
        this.wrapper.anchorEl.hidden = hidden;

        let mapRect = window.map_bounds();
        let contentRect = this.wrapper.contentEl.getBoundingClientRect();

        // Move the map to make the popup visible.
        if (!this.wrapper.moved) {
          let margin = 10;
          let topDiff = contentRect.top - mapRect.top;
          let panY = (topDiff < 0 && topDiff - margin) || 0;
          let leftDiff = contentRect.left - mapRect.left;
          let rightDiff = contentRect.right - mapRect.right;
          let panX =
            (leftDiff < 0 && leftDiff - margin) ||
            (rightDiff > 0 && rightDiff + margin) ||
            0;
          if (panX != 0 || panY != 0) {
            this.wrapper.maps.panBy(panX, panY);
          }
          this.wrapper.moved = true;
        }
      }
    })(this);

    this.maps = null;
    this.loc = null;
    this.moved = false;

    this.contentEl = document.createElement('div');
    this.contentEl.classList.add('map-popup-bubble-content');
    this.contentEl.innerHTML = content;

    let pixelOffsetEl = document.createElement('div');
    pixelOffsetEl.classList.add('map-popup-bubble-anchor');
    pixelOffsetEl.appendChild(this.contentEl);

    this.anchorEl = document.createElement('div');
    this.anchorEl.classList.add('map-popup-tip-anchor');
    this.anchorEl.appendChild(pixelOffsetEl);

    // Stop clicks, etc. from bubbling up to the map.
    let anchor = this.anchorEl;
    anchor.style.cursor = 'auto';

    let events = [
      'click',
      'dblclick',
      'contextmenu',
      'wheel',
      'mousedown',
      'touchstart',
      'pointerdown',
    ];
    events.forEach(event =>
      anchor.addEventListener(event, e => e.stopPropagation())
    );
  }

  get position() {
    return this.loc;
  }
  set position(loc) {
    assert(
      !this.native.getMap(),
      'setPosition has to be called before map is set'
    );
    this.loc = loc;
  }

  get marker() {
    return this._marker;
  }
  set marker(marker) {
    this._marker = marker;
  }

  get attached() {
    return this.maps;
  }
  attachTo(maps) {
    this.maps = maps;
    this.native.setMap(this.maps.native);
  }

  deattach() {
    this.native.setMap(null);
    this.maps = null;
  }
}

export { PopupGoogleMaps };
